import React from 'react';
import "./App.css";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Login from './Pages/Auth/Login';
import Register from './Pages/Auth/Register';
// App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Pages/Home/Home';
import SetAvatar from './Pages/Avatar/setAvatar';
import Landing from './Pages/Landing/Landing';
import Insights from './Pages/Insights/Insights';
import Shell from './components/Shell';


const App = () => {
  return (
    
      <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/setAvatar" element={<SetAvatar/>} />
          <Route element={<Shell />}>
            <Route path="/dashboard" element={<Home />} />
            <Route path="/insights" element={<Insights />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </div>
  )
}

export default App